import "./ShowroomExperience.module.css";
import Header from "@/reusable_sections/Header";
import Introduction from "./sections/Introduction";
import ExploreOurProductCategories from "./sections/ExploreOurProductCategories";
import BrandsWeWorkWith from "./sections/BrandsWeWorkWith";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
import InteractiveTabs from "./sections/InteractiveTabs";
import BrandsPartners from "./sections/BrandsPartners";
import ShowroomExperienceContent from "./sections/ShowroomExperienceContent";
export default function ShowroomExperiencePage() {
  return <div>
      <Header />
      <Introduction />
      <ShowroomExperienceContent />
      <ExploreOurProductCategories />
      <InteractiveTabs />
      <BrandsWeWorkWith />
      <BrandsPartners />
      <CallToAction />
      <Footer />
    </div>;
}